import { Dialog } from '@headlessui/react';

interface SaveSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  plantName: string;
  plantId: string;
  onViewPlant: () => void;
  onAddAnother: () => void;
  onDone: () => void;
}

export function SaveSuccessModal({
  isOpen,
  onClose,
  plantName,
  onViewPlant,
  onAddAnother,
  onDone,
}: SaveSuccessModalProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto w-full max-w-sm rounded-lg bg-white border border-gray-200 p-6 shadow-elevated">
          {/* Success icon */}
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-success/10">
            <span
              className="material-symbols-outlined text-success"
              style={{ fontSize: 32 }}
              aria-hidden="true"
            >
              check_circle
            </span>
          </div>

          <Dialog.Title className="text-center text-xl font-display font-bold text-editorial-black">
            Plant Added!
          </Dialog.Title>

          <Dialog.Description className="mt-2 text-center font-serif text-gray-500">
            {plantName} has been added to your collection.
          </Dialog.Description>

          <div className="mt-6 space-y-3">
            <button
              onClick={onViewPlant}
              className="btn-editorial group"
              aria-label={`View ${plantName} details`}
            >
              <span>View Plant</span>
              <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform" style={{ fontSize: 20 }} aria-hidden="true">
                arrow_forward
              </span>
            </button>
            <button
              onClick={onAddAnother}
              className="w-full h-12 rounded-lg border border-gray-300 px-4 font-sans font-bold text-xs uppercase tracking-widest text-editorial-black transition-colors hover:border-gray-500"
            >
              Add Another
            </button>
            <button
              onClick={onDone}
              className="w-full h-12 rounded-lg px-4 font-sans text-sm text-gray-400 transition-colors hover:text-editorial-black"
            >
              Done
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
